import { render, staticRenderFns } from "./detailsDialog.vue?vue&type=template&id=12d08fdd&"
import script from "./detailsDialog.vue?vue&type=script&lang=js&"
export * from "./detailsDialog.vue?vue&type=script&lang=js&"
import style0 from "./detailsDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports